export {default} from './RotatedView';
